import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../business/home'),
  },
  {
    path: '/searchdetail',
    name: 'SearchDetail',
    component: () => import('../business/home/searchDetail'),
  },
  {
    path: '/project',
    name: 'project',
    component: () => import('../business/home/project'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../business/about'),
  },
  {
    path: '/case',
    name: 'Case',
    component: () => import('../business/case'),
  },
  {
    path: '/case/casedetail',
    name: 'Casedetail',
    component: () => import('../business/case/caseDetail'),
  },
  {
    path: '/solution',
    name: 'Solution',
    component: () => import('../business/solution'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../business/contact'),
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../business/news'),
  },
  {
    path: '/news/newsdetail',
    name: 'Newsdetail',
    component: () => import('../business/news/newsDetail'),
  },
  {
    path: '/smartschool/faceRecognition',
    name: 'Ssfacerecognition',
    component: () => import('../business/smart/smartSchool/faceRecognition'),
  },
  {
    path: '/smartschool/ledScreen',
    name: 'Ssledscreen',
    component: () => import('../business/smart/smartSchool/ledScreen'),
  },
  {
    path: '/smartschool/carRecognition',
    name: 'Sscarrecognition',
    component: () => import('../business/smart/smartSchool/carRecognition'),
  },
  {
    path: '/smartschool/hdCampusTV',
    name: 'SshdcampusTV',
    component: () => import('../business/smart/smartSchool/hdCampusTV'),
  },
  {
    path: '/smartschool/monitoringSystem',
    name: 'Ssmonitoringsystem',
    component: () => import('../business/smart/smartSchool/monitoringSystem'),
  },
  {
    path: '/smartschool/campuselEctronicfence',
    name: 'SscampuselEctronicfence',
    component: () => import('../business/smart/smartSchool/campuselEctronicfence'),
  },
  {
    path: '/smartschool/campusRadio',
    name: 'SscampuselRadio',
    component: () => import('../business/smart/smartSchool/campusRadio'),
  },
  {
    path: '/smartschool/cardIntegration',
    name: 'Sscardintegration',
    component: () => import('../business/smart/smartSchool/cardIntegration'),
  },
  {
    path: '/smartschool/wisdomClasscard',
    name: 'Sswisdomclasscard',
    component: () => import('../business/smart/smartSchool/wisdomClasscard'),
  },
  {
    path: '/smartschool/wisdomRecordbroad',
    name: 'SswisdomRecordbroad',
    component: () => import('../business/smart/smartSchool/wisdomRecordbroad'),
  },
  {
    path: '/smartschool/intelligentLift',
    name: 'SsintelligentLift',
    component: () => import('../business/smart/smartSchool/intelligentLift'),
  },
  {
    path: '/smartschool/intelligentChannel',
    name: 'SsintelligentChannel',
    component: () => import('../business/smart/smartSchool/intelligentChannel'),
  },
  {
    path: '/smartschool/campusfamilyPhone',
    name: 'SscampusfamilyPhone',
    component: () => import('../business/smart/smartSchool/campusfamilyPhone'),
  },
  {
    path: '/smartcommunity/electricCarpile',
    name: 'ScelectricCarpile',
    component: () => import('../business/smart/smartCommunity/electricCarpile'),
  },
  {
    path: '/smartcommunity/intelligentScreen',
    name: 'ScintelligentScreen',
    component: () => import('../business/smart/smartCommunity/intelligentScreen'),
  },
  {
    path: '/smartcommunity/wisdomBusinessSuper',
    name: 'ScwisdomBusinessSuper',
    component: () => import('../business/smart/smartCommunity/wisdomBusinessSuper'),
  },
  {
    path: '/smartcommunity/faceRecognition',
    name: 'ScfaceRecognition',
    component: () => import('../business/smart/smartCommunity/faceRecognition'),
  },
  {
    path: '/smartcommunity/emotionlessParking',
    name: 'ScemotionlessParking',
    component: () => import('../business/smart/smartCommunity/emotionlessParking'),
  },
  {
    path: '/smartbuilding/intelligentSite',
    name: 'intelligentSite',
    component: () => import('../business/smart/smartbuilding/intelligentSite'),
  },
  {
    path: '/smartScenic/bigdataanalyticsapplicationtypeSystem',
    name: 'bigdataanalyticsapplicationtypeSystem',
    component: () => import('../business/smart/smartScenic/bigdataanalyticsapplicationtypeSystem'),
  },
  {
    path: '/smartScenic/environmentalmonitoringSystem',
    name: 'environmentalmonitoringSystem',
    component: () => import('../business/smart/smartScenic/environmentalmonitoringSystem'),
  },
  {
    path: '/smartScenic/integratedbusinessmanagerSystem',
    name: 'integratedbusinessmanagerSystem',
    component: () => import('../business/smart/smartScenic/integratedbusinessmanagerSystem'),
  },
  {
    path: '/smartScenic/intelligentbroadcastSystem',
    name: 'intelligentbroadcastSystem',
    component: () => import('../business/smart/smartScenic/intelligentbroadcastSystem'),
  },
  {
    path: '/smartScenic/intelligentvideosurveillanceSystem',
    name: 'intelligentvideosurveillanceSystem',
    component: () => import('../business/smart/smartScenic/intelligentvideosurveillanceSystem'),
  },

  {
    path: '/smartScenic/promotemarketSystem',
    name: 'promotemarketSystem',
    component: () => import('../business/smart/smartScenic/promotemarketSystem'),
  },
  {
    path: '/smartScenic/scenicfarecollectionSystem',
    name: 'scenicfarecollectionSystem',
    component: () => import('../business/smart/smartScenic/scenicfarecollectionSystem'),
  },
  {
    path: '/smartScenic/scenicparkmanagerSystem',
    name: 'scenicparkmanagerSystem',
    component: () => import('../business/smart/smartScenic/scenicparkmanagerSystem'),
  },
  {
    path: '/smartScenic/smartnavigationSystem',
    name: 'smartnavigationSystem',
    component: () => import('../business/smart/smartScenic/smartnavigationSystem'),
  },
  {
    path: '/smartScenic/smartsceniccosumeSystem',
    name: 'smartsceniccosumeSystem',
    component: () => import('../business/smart/smartScenic/smartsceniccosumeSystem'),
  },
  {
    path: '/smartScenic/smartscenicspotdistributionSystem',
    name: 'smartscenicspotdistributionSystem',
    component: () => import('../business/smart/smartScenic/smartscenicspotdistributionSystem'),
  },
  {
    path: '/smartScenic/videofusionSystem',
    name: 'videofusionSystem',
    component: () => import('../business/smart/smartScenic/videofusionSystem'),
  },

  {
    path: '/legal',
    name: 'Legal',
    component: () => import('../business/legal'),
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});
export default router;
